"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _gtmService = require("../../data/gtmService/gtmService");
var _quoteToolDataContextProvider = require("../../contextProviders/quoteToolDataContextProvider");
var _componentKeyMap = require("../Steps/componentKeyMap");
var _navigationContext = require("../../contextProviders/navigationContext");
var _brandContext = require("../../contextProviders/brandContext");
var _slice = require("../../store/app/slice");
var _session = require("../../helpers/session");
var _selectors = require("../../store/app/selectors");
var _selectors2 = require("../../store/quote/selectors");
var _quoteValidators = require("../../data/quote/quoteValidators");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StepContent = exports.StepContent = function StepContent(_ref) {
  var _ref$activeStepIndex = _ref.activeStepIndex,
    activeStepIndex = _ref$activeStepIndex === void 0 ? 0 : _ref$activeStepIndex;
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext$activeBra = _useContext.activeBrandContext,
    partner = _useContext$activeBra.brand.partner,
    adFixus = _useContext$activeBra.marketing.adFixus;
  var _useOutletContext = (0, _reactRouterDom.useOutletContext)(),
    stepDefinitions = _useOutletContext.stepDefinitions;
  var stepDetails = stepDefinitions[activeStepIndex];
  var _useContext2 = (0, _react.useContext)(_quoteToolDataContextProvider.QuoteToolDataContext),
    routeStateDispatcher = _useContext2.routeStateDispatcher;
  var gtmService = (0, _gtmService.getGtmService)();
  var navigate = (0, _reactRouterDom.useNavigate)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.sessionSelector),
    sessionStartTime = _useSelector.sessionStartTime;
  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors2.savedQuoteSelector),
    quote = _useSelector2.quote;
  var navigationController = (0, _react.useCallback)(function (newUrl, quoteResponse) {
    var _window;
    (_window = window) === null || _window === void 0 || _window.scrollTo(0, 0);
    if (!sessionStartTime) {
      (0, _session.setSessionTimeout)({
        dispatch: dispatch,
        setSessionStartTime: _slice.setSessionStartTime
      });
    }
    var isSessionValid = (0, _session.checkSessionTimeout)({
      dispatch: dispatch,
      setIsSessionValid: _slice.setIsSessionValid
    }, sessionStartTime);
    if (isSessionValid) {
      routeStateDispatcher({
        type: 'setRouteComplete',
        routeIndex: activeStepIndex
      });
    } else {
      navigate('/error', {
        state: {
          title: 'Application Session Timeout',
          message: 'Please start a new quote'
        }
      });
    }
    if (quoteResponse) {
      var isResponseValid = (0, _quoteValidators.validateAndProceedToNextStep)(stepDetails, quoteResponse);
      if (!isResponseValid) {
        return navigate('/error', {
          state: {
            title: 'Invalid Quote Data',
            message: 'Quote is not valid. Please retry or contact us.',
            buttonText: 'Retry',
            customPath: "/".concat(stepDetails === null || stepDetails === void 0 ? void 0 : stepDetails.url)
          }
        });
      }
    }
    return navigate(newUrl);
  }, [sessionStartTime, dispatch, navigate, routeStateDispatcher, activeStepIndex, stepDetails]);
  (0, _react.useEffect)(function () {
    var _stepDefinitions$acti = stepDefinitions[activeStepIndex],
      currentPath = _stepDefinitions$acti.url,
      pageTitle = _stepDefinitions$acti.label;
    if (adFixus) {
      gtmService.pushAdFixusGA3PageView(currentPath, pageTitle);
    } else {
      gtmService.pushGA3PageView(currentPath, pageTitle);
    }
    gtmService.pushGA4PageView({
      partnerName: partner,
      partnerCode: partner,
      partnerCategory: null,
      stepName: pageTitle,
      stepNumber: currentPath
    });
    gtmService.pushUserId(quote);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStepIndex]);
  var providedValues = (0, _react.useMemo)(function () {
    return {
      navigationController: navigationController
    };
  }, [navigationController]);
  return /*#__PURE__*/_react["default"].createElement(_navigationContext.NavigationContext.Provider, {
    value: providedValues
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stepContent"
  }, _componentKeyMap.ComponentKeyMap[stepDefinitions[activeStepIndex].componentKey]));
};
StepContent.propTypes = {
  activeStepIndex: _propTypes["default"].number
};